var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.white)?_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":'/musicologie-wordmark-300.webp'}}):_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":'/Musicologie-White-Wordmark.png'}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }